export default "__VITE_ASSET__d1fadb4b__"